<template>
  <jet-dialog-modal icon="fas fa-map-marker-alt" :id="modalId">
    <template #title>{{modalTitle}}</template>
    <template #content>
      <div class="row">
        <div class="form-group col-sm-6">
          <jet-label class="mb-0" for="company_name" value="Company Name" />
          <jet-input id="company_name"  type="text" class="form-control" v-model="form.company_name" />
          <jet-input-error :message="form.errors.company_name" class="mt-2" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-6">
          <jet-label class="mb-0" for="address1" value="Address" />
          <GMapAutocomplete
            :id="modalAutoField"
            class="form-control"
            placeholder="Address"
            @place_changed="getAddressData"
          />
        </div>
        <div class="form-group col-sm-6">
          <jet-label class="mb-0" for="address2" value="Unit / Suite" />
          <jet-input id="address2"  type="text" class="form-control" v-model="form.address2" />
          <jet-input-error :message="form.errors.address2" class="mt-2" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-6">
          <jet-label class="mb-0" for="city" value="City" />
          <jet-input id="city"  type="text" class="form-control" v-model="form.city" />
          <jet-input-error :message="form.errors.city" class="mt-2" />
        </div>
        <div class="form-group col-sm-6">
          <jet-label class="mb-0" for="state" value="State" />
          <select v-model="form.state" class="form-control">
            <option v-for="state in this.states" :key="state.id" :value="state.code">
              {{ state.code }} - {{ state.name }}
            </option>
          </select>
          <jet-input-error :message="form.errors.state" class="mt-2" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-4">
          <jet-label class="mb-0" for="postcode" value="Zip" />
          <jet-input id="postcode"  type="text" class="form-control" v-model="form.postcode" />
          <jet-input-error :message="form.errors.postcode" class="mt-2" />
        </div>
        <div class="form-group col-sm-4">
          <jet-label class="mb-0" for="phone" value="Phone" />
          <jet-input id="phone"  type="text" class="form-control" v-model="form.phone" />
          <jet-input-error :message="form.errors.phone" class="mt-2" />
        </div>
        <div class="form-group col-sm-4">
          <jet-label class="mb-0" for="phone_mobile" value="Alt Phone" />
          <jet-input id="phone_mobile"  type="text" class="form-control" v-model="form.phone_mobile" />
          <jet-input-error :message="form.errors.phone_mobile" class="mt-2" />
        </div>
      </div>

      <div class="form-group">
        <label class="mb-0" for="day-of-week">Day of Week</label>
        <select id="day-of-week" v-model="form.location_visit_on_day" class="form-control">
          <option :value="null">Unassigned</option>
          <option v-for="day in days" :key="day.dayIndex" :value="day.dayIndex">{{ day.name }}</option>
        </select>
      </div>
    </template>

    <template #footer>
      <jet-button icon="fas fa-location-arrow" @click="submitLocation">{{modalTitle}}</jet-button>
      <jet-danger-button data-dismiss="modal" class="ml-2">Cancel</jet-danger-button>
    </template>
  </jet-dialog-modal>
</template>

<script>
  import JetDangerButton from '@/Jetstream/DangerButton'
  import JetDialogModal from '@/Jetstream/DialogModal'
  import JetInput from '@/Jetstream/Input'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import Helpers from '@/Helpers'

  export default {
    emits: ['saveLocation', 'updateLocation', 'beforeSaveLocation'],
    components: {
      JetDangerButton,
      JetDialogModal,
      JetInput,
      JetInputError,
      JetLabel
    },
    props: {
      form: Object,
      states: Array,
      updates: Boolean,
      edit: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        days: [
          { name: 'Monday', dayIndex: 1 },
          { name: 'Tuesday', dayIndex: 2 },
          { name: 'Wednesday', dayIndex: 3 },
          { name: 'Thursday', dayIndex: 4 },
          { name: 'Friday', dayIndex: 5 },
          { name: 'Saturday', dayIndex: 6 },
          { name: 'Sunday', dayIndex: 0 },
        ]
      }
    },
    computed: {
      modalId() {
        return this.edit ? 'editLocationModal' : 'locationModal'
      },
      modalAutoField() {
        // this is stupid
        return this.edit ? 'editaddress1' : 'address1'
      },
      modalTitle() {
        return this.edit ? 'Edit Location' : 'New Location'
      }
    },
    methods: {
      getAddressData(info) {
        const city = Helpers.getAddressComponent('locality', info)
        const state = Helpers.getAddressComponent('administrative_area_level_1', info)
        const zipcode = Helpers.getAddressComponent('postal_code', info)

        const street_number = Helpers.getAddressComponent('street_number', info)
        const route = Helpers.getAddressComponent('route', info)
        let address1 = '';
        if (street_number.length && route.length) {
          address1 = street_number[0].long_name + ' ' + route[0].short_name;
        } else if (info.name) {
          address1 = info.address
        }
        this.form.address1 = address1
        document.getElementById(this.modalAutoField).value = address1
     
        if (city.length) this.form.city = city[0].long_name
        if (state.length) this.form.state = state[0].short_name
        if (zipcode.length) this.form.postcode = zipcode[0].long_name
      },
      hideForm() {
        $(`#${this.modalId}`).modal('hide')

        if (!this.edit) {
          this.form.company_name = null
          document.getElementById(this.modalAutoField).value = ''
          this.form.address2 = null
          this.form.city = null
          this.form.state = null
          this.form.postcode = null
          this.location_form_on_day = null
        }
      },
      submitLocation() {
        this.form.address1 = document.getElementById(this.modalAutoField).value
        // If the method is mtd.locations.update. let the parent component handle the logic
        if (this.updates) {
          this.$emit('updateLocation')
          return
        }

        else {
          // else, handle the success logic and create a callback if the parent needs to do additional data handling
          this.form.post(route('mtd.locations.store'), {
          preserveScroll: true,
            onStart: () => this.$emit('beforeSaveLocation'),
            onSuccess: () => {
              this.$emit('saveLocation', this.form)
              this.hideForm()
            }
          })
        }
      }
    }
  }
</script>
